// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#facility-edit[data-v-8943ae58]{max-width:700px;margin-left:auto;margin-right:auto}#facility-edit .note[data-v-8943ae58]{margin:0 20px 20px 20px}#facility-edit .cancel-btn[data-v-8943ae58],#facility-edit .update-btn[data-v-8943ae58]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
